var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCrown = function SvgCrown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.896641 4.97371C0.885401 4.97646 0.87416 4.97646 0.862055 4.97646L0.864649 4.97279C0.389092 4.97279 0 4.56099 0 4.05381C0 3.54662 0.388227 3.13666 0.868108 3.13666C1.34539 3.13666 1.73276 3.54662 1.73276 4.05381C1.73276 4.15286 1.71719 4.24733 1.68952 4.33629L3.77852 5.63131L6.02401 1.68389C5.78883 1.51972 5.63492 1.23815 5.63492 0.917151C5.63492 0.412718 6.02315 0 6.5013 0C6.97858 0 7.36768 0.411801 7.36768 0.918985C7.36768 1.23815 7.21204 1.51972 6.97858 1.68481L9.22321 5.63131L11.3122 4.33629C11.2828 4.24641 11.269 4.15194 11.269 4.05381C11.269 3.54662 11.6563 3.13666 12.1336 3.13666C12.6109 3.13666 13 3.54662 13 4.05381C13 4.56283 12.6118 4.97554 12.1319 4.97554L12.0973 4.97371L10.9421 9.4063H2.05095L0.896641 4.97371ZM10.668 10.4555C11.0701 10.4555 11.3961 10.8004 11.3961 11.2278C11.3961 11.6533 11.0701 12 10.668 12H2.32418C1.92298 12 1.59788 11.6552 1.59788 11.2278C1.59788 10.8004 1.92298 10.4555 2.32418 10.4555H10.668Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crown.bc42d795.svg";
export { ForwardRef as ReactComponent };